import styled from 'styled-components';
import Button from '@carvana/showroom-forms/Button/Primary';

const GarageInactiveWrapper = styled.div`
  margin: 0;
`;

const Description = styled.p`
  color: ${(props) => props.theme.color.primary.v600};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin: 16px 0 24px;

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    margin: 8px 0 24px;
  }
`;

const SearchCarsButton = styled(Button)`
  width: 100%;
`;

export { GarageInactiveWrapper, Description, SearchCarsButton };
